// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { GridOffset } from "@insite/mobius/GridContainer";
import { mergeWithCss } from "@vanmeter/XDL/Utilities";
import { modalButtonsActionStyles } from "@vanmeter/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

scheduleReminderModalStyles.contentContainer = { gap: 0 };

scheduleReminderModalStyles.modal = {
    sizeVariant: "medium",
};

scheduleReminderModalStyles.titleText = {
    variant: "h4",
    css: css`
        &&& {
            margin-bottom: 0;
        }
    `,
};

scheduleReminderModalStyles.hintText = {
    size: 15,
    css: css`
        margin-top: 5px;
    `,
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = scheduleReminderModalStyles.startDatePicker;

scheduleReminderModalStyles.middleRowLeftColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.middleRowRightColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.frequencyRadioGroup = {
    horizontal: true,
};

scheduleReminderModalStyles.weeklyRadio = {};

scheduleReminderModalStyles.monthlyRadio = {};

scheduleReminderModalStyles.bottomRowGridItem = {
    width: 12,
};

scheduleReminderModalStyles.buttonsContainer = {
    gap: 0,
    css: css`
        & ${GridOffset} {
            flex-wrap: wrap;
            justify-content: space-between;
        }
    `,
};

scheduleReminderModalStyles.stopButtonGridItem = {
    width: 12,
};

scheduleReminderModalStyles.cancelButtonsGridItem = scheduleReminderModalStyles.cancelButtonGridItem = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            &&& {
                margin-top: 16px;
            }
        `,
    }),
};

scheduleReminderModalStyles.stopButton = {
    variant: "secondary",
    css: css`
        margin-top: 12px;
    `,
};

scheduleReminderModalStyles.dismissCancelButton = scheduleReminderModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

scheduleReminderModalStyles.confirmCancelButton = scheduleReminderModalStyles.scheduleButton = {
    ...modalButtonsActionStyles.submitButton,
};
